(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artisan-barra-avisos"] && !Shopify.designMode) return;
  try {
    
  class ArtisanAvisos extends HTMLElement {
    connectedCallback() {
      this.mensagens = Array.from(this.querySelectorAll('.artisan-avisos__mensagem'));
      if (this.mensagens.length < 2) return;

      const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (semMovimento.matches) return;

      this.atual = 0;
      this.intervalo = Number(this.dataset.intervalo || 5000);

      this.querySelectorAll('[data-direcao]').forEach((botao) => {
        botao.addEventListener('click', () => {
          this.mover(botao.dataset.direcao === 'proximo' ? 1 : -1);
          this.reiniciar();
        });
      });

      // Para de girar enquanto o visitante esta lendo ou usando o teclado.
      this.addEventListener('mouseenter', () => this.parar());
      this.addEventListener('mouseleave', () => this.reiniciar());
      this.addEventListener('focusin', () => this.parar());
      this.addEventListener('focusout', () => this.reiniciar());

      this.reiniciar();
    }

    disconnectedCallback() {
      this.parar();
    }

    mover(passo) {
      this.mensagens[this.atual].hidden = true;
      this.atual = (this.atual + passo + this.mensagens.length) % this.mensagens.length;
      this.mensagens[this.atual].hidden = false;
    }

    parar() {
      clearInterval(this.timer);
    }

    reiniciar() {
      this.parar();
      this.timer = setInterval(() => this.mover(1), this.intervalo);
    }
  }

  customElements.define('artisan-avisos', ArtisanAvisos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-cabecalho"]) return;
  try {
    
  class ArtisanCabecalho extends HTMLElement {
    connectedCallback() {
      this.ligarSubmenus();
      this.ligarRolagem();
    }

    ligarSubmenus() {
      this.abertos = this.querySelectorAll('[data-submenu]');

      this.abertos.forEach((gatilho) => {
        const painel = this.querySelector('#' + gatilho.dataset.submenu);
        if (!painel) return;
        const pai = gatilho.closest('.artisan-cab__item');

        let timerFechar;
        const abrir = () => {
          clearTimeout(timerFechar);
          this.fecharSubmenus();
          painel.hidden = false;
          gatilho.setAttribute('aria-expanded', 'true');
        };
        const fechar = () => {
          painel.hidden = true;
          gatilho.setAttribute('aria-expanded', 'false');
        };

        // No desktop o submenu abre no hover. No toque e no teclado ele
        // abre no clique, e o primeiro clique nao segue o link.
        pai.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) abrir();
        });
        // Fecha com um respiro de 300 ms: um desvio rapido do mouse no
        // caminho ate o submenu nao fecha o painel.
        pai.addEventListener('mouseleave', () => {
          clearTimeout(timerFechar);
          timerFechar = setTimeout(fechar, 300);
        });
        pai.addEventListener('mouseenter', () => clearTimeout(timerFechar));

        gatilho.addEventListener('click', (evento) => {
          if (painel.hidden) {
            evento.preventDefault();
            abrir();
          }
        });

        pai.addEventListener('focusout', (evento) => {
          if (!pai.contains(evento.relatedTarget)) fechar();
        });
      });

      document.addEventListener('keydown', (evento) => {
        if (evento.key === 'Escape') this.fecharSubmenus();
      });
    }

    fecharSubmenus() {
      this.querySelectorAll('.artisan-cab__submenu').forEach((p) => (p.hidden = true));
      this.querySelectorAll('[data-submenu]').forEach((g) => g.setAttribute('aria-expanded', 'false'));
    }

    ligarRolagem() {
      let anterior = window.scrollY;

      window.addEventListener(
        'scroll',
        () => {
          const atual = window.scrollY;
          const desceu = atual > anterior && atual > 160;
          // Enquanto um submenu ou a busca estiverem abertos, o cabecalho fica.
          const ocupado = this.querySelector('[aria-expanded="true"]') !== null;
          this.dataset.escondido = desceu && !ocupado ? 'true' : 'false';
          anterior = atual;
        },
        { passive: true }
      );
    }
  }

  customElements.define('artisan-cabecalho', ArtisanCabecalho);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-carrinho-pagina"]) return;
  try {
    
  /* A observacao da entrega e salva no carrinho ao sair do campo. */
  const nota = document.querySelector('[data-nota-carrinho]');
  if (nota) nota.addEventListener('change', () => {
    fetch(`${window.Shopify.routes.root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: nota.value }) });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-colecao"]) return;
  try {
    
  document.addEventListener('click', async (evento) => {
    const botao = evento.target.closest('[data-carregar-mais]');
    if (!botao) return;
    evento.preventDefault();
    const grade = document.querySelector('[data-grade-colecao]');
    if (!grade) return;
    const textoOriginal = botao.textContent.trim();
    botao.textContent = botao.dataset.carregando;
    botao.setAttribute('aria-disabled', 'true');
    try {
      const html = await fetch(botao.href).then((r) => r.text());
      const pagina = new DOMParser().parseFromString(html, 'text/html');
      pagina.querySelectorAll('[data-grade-colecao] > *').forEach((card) => grade.appendChild(card));
      const mostrados = document.querySelector('[data-mostrados]');
      if (mostrados) mostrados.textContent = grade.children.length;
      const proximo = pagina.querySelector('[data-carregar-mais]');
      if (proximo) {
        botao.href = proximo.href;
        botao.textContent = textoOriginal;
        botao.removeAttribute('aria-disabled');
      } else {
        botao.closest('.artisan-col__mais').remove();
      }
    } catch (erro) {
      botao.textContent = textoOriginal;
      botao.removeAttribute('aria-disabled');
      window.location.href = botao.href;
    }
  });

  /* Filtro de preparo: carrega as paginas que faltam e esconde os cards
     sem o modo escolhido. Dois modos ligados mostram quem tem qualquer um. */
  (() => {
    const grupo = document.querySelector('[data-filtro-preparo]');
    if (!grupo) return;
    const grade = document.querySelector('[data-grade-colecao]');
    if (!grade) return;
    const contagem = document.querySelector('[data-contagem-colecao]');
    const textoContagem = contagem ? contagem.innerHTML : '';

    async function carregarTudo() {
      let botao = document.querySelector('[data-carregar-mais]');
      while (botao) {
        const html = await fetch(botao.href).then((r) => r.text());
        const pagina = new DOMParser().parseFromString(html, 'text/html');
        pagina.querySelectorAll('[data-grade-colecao] > *').forEach((card) => grade.appendChild(card));
        const proximo = pagina.querySelector('[data-carregar-mais]');
        if (proximo) {
          botao.href = proximo.href;
        } else {
          botao.closest('.artisan-col__mais').remove();
          botao = null;
        }
      }
    }

    function aplicar() {
      const modos = [...grupo.querySelectorAll('[aria-pressed="true"]')].map((b) => b.dataset.modo);
      let visiveis = 0;
      [...grade.children].forEach((card) => {
        const tem = (card.querySelector('[data-preparo]') || card).dataset.preparo || '';
        const mostra = modos.length === 0 || modos.some((m) => tem.split(' ').includes(m));
        if (mostra) { card.removeAttribute('data-preparo-oculto'); visiveis += 1; }
        else card.setAttribute('data-preparo-oculto', '');
      });
      if (contagem) {
        contagem.innerHTML = modos.length === 0 ? textoContagem
          : visiveis + (visiveis === 1 ? ' produto' : ' produtos') + ' com este preparo';
      }
    }

    grupo.addEventListener('click', async (evento) => {
      const botao = evento.target.closest('[data-modo]');
      if (!botao) return;
      botao.setAttribute('aria-pressed', botao.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      if (grupo.querySelector('[aria-pressed="true"]')) {
        try { await carregarTudo(); } catch (erro) { /* fica com o que ja carregou */ }
      }
      aplicar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-faq"] && !Shopify.designMode) return;
  try {
    
  class ArtisanFaq extends HTMLElement {
    connectedCallback() {
      const busca = this.querySelector('[data-faq-busca]'); if (!busca) return;
      const itens = Array.from(this.querySelectorAll('[data-faq-item]'));
      const grupos = Array.from(this.querySelectorAll('[data-faq-grupo]'));
      const caixas = Array.from(this.querySelectorAll('[data-faq-caixa]'));
      const nada = this.querySelector('[data-faq-nada]');
      const semAcento = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      busca.addEventListener('input', () => {
        const termo = semAcento(busca.value.trim());
        let vistos = 0;
        itens.forEach((it) => { const ok = !termo || semAcento(it.dataset.busca).includes(termo); it.hidden = !ok; if (ok) vistos++; if (termo && ok) it.open = true; });
        caixas.forEach((c) => (c.hidden = !!termo));
        grupos.forEach((g) => {
          let el = g.nextElementSibling, tem = false;
          while (el && !el.hasAttribute('data-faq-grupo')) { if (el.hasAttribute('data-faq-item') && !el.hidden) tem = true; el = el.nextElementSibling; }
          g.hidden = !tem;
        });
        if (nada) nada.hidden = vistos > 0;
      });
    }
  }
  customElements.define('artisan-faq', ArtisanFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-formulario"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function marcar(params) {
      var achou = null;
      document.querySelectorAll('select[data-parametro]').forEach(function (campo) {
        var valor = params.get(campo.dataset.parametro);
        if (!valor) return;
        valor = valor.trim().toLowerCase();
        Array.prototype.forEach.call(campo.options, function (opcao) {
          if (opcao.value.toLowerCase() === valor) {
            campo.value = opcao.value;
            achou = campo;
          }
        });
      });
      return achou;
    }

    marcar(new URLSearchParams(location.search));

    document.addEventListener('click', function (evento) {
      var link = evento.target.closest('a[href*="#"]');
      if (!link) return;
      var destino = new URL(link.href, location.href);
      if (destino.pathname !== location.pathname || !destino.search) return;
      var alvo = document.getElementById(destino.hash.slice(1));
      if (!alvo || !marcar(destino.searchParams)) return;
      evento.preventDefault();
      history.replaceState(null, '', destino.search + destino.hash);
      alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-pontos-venda"]) return;
  try {
    
  class ArtisanPontos extends HTMLElement {
    connectedCallback() {
      this.busca = this.querySelector('[data-busca]');
      this.selEstado = this.querySelector('[data-filtro-estado]');
      this.selCidade = this.querySelector('[data-filtro-cidade]');
      this.contagem = this.querySelector('[data-contagem]');
      this.vazio = this.querySelector('[data-vazio]');
      this.escolha = this.querySelector('[data-escolha]');
      this.estadosCards = this.querySelector('[data-estados]');
      this.dica = this.querySelector('[data-dica]');
      this.dicaOriginal = this.dica ? this.dica.textContent : '';
      this.estados = Array.from(this.querySelectorAll('[data-estado]'));
      this.itens = Array.from(this.querySelectorAll('.artisan-pdv__item'));
      this.total = this.itens.length;

      let dados = {};
      try { dados = JSON.parse(this.querySelector('[data-pdv-cidades]').textContent); } catch (e) {}
      this.cidades = dados;

      this.querySelectorAll('.artisan-pdv__estado-card').forEach((card) => {
        const uf = card.dataset.escolherEstado;
        const nome = card.querySelector('.artisan-pdv__uf-nome').textContent;
        const opt = document.createElement('option'); opt.value = uf; opt.textContent = nome;
        this.selEstado.appendChild(opt);
        card.addEventListener('click', () => { this.selEstado.value = uf; this.trocarEstado(); });
      });

      this.selEstado.addEventListener('change', () => this.trocarEstado());
      this.selCidade.addEventListener('change', () => this.filtrar());
      this.busca.addEventListener('input', () => this.filtrar());
    }

    semAcento(t) { return t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }

    trocarEstado() {
      const uf = this.selEstado.value;
      this.selCidade.innerHTML = '';
      if (uf && this.cidades[uf]) {
        this.selCidade.disabled = false;
        this.selCidade.appendChild(new Option('Todas as cidades', ''));
        this.cidades[uf].forEach((c) => this.selCidade.appendChild(new Option(c, c)));
      } else {
        this.selCidade.disabled = true;
        this.selCidade.appendChild(new Option('Escolha o estado primeiro', ''));
      }
      this.querySelectorAll('.artisan-pdv__estado-card').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.escolherEstado === uf)));
      this.filtrar();
    }

    filtrar() {
      const termo = this.semAcento(this.busca.value.trim());
      const uf = this.selEstado.value;
      const cidade = this.selCidade.disabled ? '' : this.selCidade.value;
      const ativo = termo.length >= 2 || uf;
      let visiveis = 0;

      this.estados.forEach((sec) => {
        let vistoNoEstado = 0;
        sec.querySelectorAll('.artisan-pdv__cidade').forEach((bloco) => {
          let vistoNaCidade = 0;
          bloco.querySelectorAll('.artisan-pdv__item').forEach((item) => {
            const passa = ativo &&
              (!uf || sec.dataset.estado === uf) &&
              (!cidade || bloco.dataset.cidade === cidade) &&
              (!termo || item.dataset.busca.includes(termo));
            item.hidden = !passa; if (passa) vistoNaCidade += 1;
          });
          bloco.hidden = vistoNaCidade === 0; vistoNoEstado += vistoNaCidade;
        });
        sec.hidden = vistoNoEstado === 0; visiveis += vistoNoEstado;
      });

      this.escolha.hidden = !!ativo;
      this.estadosCards.hidden = !!ativo;
      this.contagem.hidden = !ativo;
      this.vazio.hidden = !(ativo && visiveis === 0);
      if (ativo) this.contagem.textContent = `${visiveis} de ${this.total} pontos`;
      if (this.dica) this.dica.textContent = ativo ? '' : this.dicaOriginal;
    }
  }
  customElements.define('artisan-pontos', ArtisanPontos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-produto"]) return;
  try {
    
  /* Quantidade, total e barra fixa. O carrinho em si e o artisan-carrinho.js. */
  (function () {
    const caixa = document.querySelector('[data-caixa-compra]');
    if (!caixa) return;

    const campoQtd = caixa.querySelector('[data-qtd-produto]');
    const preco = caixa.querySelector('[data-preco]');
    const total = caixa.querySelector('[data-total]');
    const barra = document.querySelector('[data-barra-compra]');

    function reais(centavos) {
      const v = (centavos / 100).toFixed(2).replace('.', ',');
      return 'R$ ' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function atualizar() {
      const qtd = Math.max(1, parseInt(campoQtd.value, 10) || 1);
      const centavos = parseInt(preco.dataset.precoCentavos, 10) || 0;
      if (total) total.textContent = reais(centavos * qtd);
      if (barra) {
        const bq = barra.querySelector('[data-barra-qtd]');
        const bp = barra.querySelector('[data-barra-preco]');
        if (bq) bq.textContent = qtd;
        if (bp) bp.textContent = reais(centavos * qtd);
      }
    }

    caixa.addEventListener('click', (evento) => {
      const passo = evento.target.closest('[data-passo]');
      if (!passo) return;
      // Aplicativos de desconto por quantidade (Easy Bundle) escutam cliques
      // na pagina inteira procurando o seletor de quantidade do tema Dawn.
      // Sem isto, o clique contava duas vezes ou mais.
      evento.stopPropagation();
      const atual = parseInt(campoQtd.value, 10) || 1;
      campoQtd.value = passo.dataset.passo === 'mais' ? atual + 1 : Math.max(1, atual - 1);
      atualizar();
    });
    campoQtd.addEventListener('input', atualizar);
    // Aplicativo que troca a quantidade por codigo (faixa "compre 3")
    // costuma avisar com 'change': o total acompanha.
    campoQtd.addEventListener('change', atualizar);

    caixa.addEventListener('artisan:variante-mudou', (evento) => {
      const v = evento.detail && evento.detail.variante;
      if (v && typeof v.price === 'number') preco.dataset.precoCentavos = v.price;
      atualizar();
    });

    /* A barra aparece quando a caixa de compra sai da tela por cima. */
    if (barra && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        (entradas) => {
          const e = entradas[0];
          barra.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        },
        { threshold: 0 }
      ).observe(caixa);

      const comprar = barra.querySelector('[data-barra-comprar]');
      if (comprar) {
        // Clica no botao principal em vez de enviar o formulario direto:
        // assim, quando o aplicativo de desconto por quantidade esta na
        // pagina, ele cuida da compra igual ao botao de cima.
        comprar.addEventListener('click', () => {
          const principal = caixa.querySelector('[data-adicionar]');
          if (principal) principal.click();
        });
      }
    }

    /* Faixa "Compre mais, ganhe mais" do Easy Bundle: quando ela aparece,
       a quantidade e o preco passam a ser dela. O nosso total e o "1 x" da
       barra fixa somem para nao mostrar valor antigo. */
    function checarFaixa() {
      const tem = !!caixa.querySelector('.gbbQbWidgetWrapper');
      document.documentElement.classList.toggle('artisan-faixa-qtd', tem);
    }
    new MutationObserver(checarFaixa).observe(caixa, { childList: true, subtree: true });
    checarFaixa();

    atualizar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-relacionados"]) return;
  try {
    
  /* Busca as recomendacoes so depois que a pagina ja apareceu. */
  (function () {
    const caixa = document.querySelector('[data-relacionados]');
    if (!caixa || caixa.querySelector('.artisan-grade')) return;

    fetch(caixa.dataset.url)
      .then((r) => r.text())
      .then((texto) => {
        const novo = new DOMParser()
          .parseFromString(texto, 'text/html')
          .querySelector('[data-relacionados]');
        if (novo) caixa.innerHTML = novo.innerHTML;
      })
      .catch(() => {
        /* Sem recomendacao, a secao simplesmente fica vazia. */
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
